import React, { useState, memo } from "react";
import Card, { CardBody, CardHeader, CardTitle } from "../../../../bootstrap/Card";
import Button from "../../../../bootstrap/Button";
import Badge from "../../../../bootstrap/Badge";
import Money from "../../../../../helpers/utils/money/money";

const PreviewStep = ({ data, allProducts, allComplements }) => {
    const [expandedCategories, setExpandedCategories] = useState({});
    const [expandedProducts, setExpandedProducts] = useState({});

    const toggleCategory = (catId) => {
        setExpandedCategories(prev => ({ ...prev, [catId]: !prev[catId] }))
    }

    const toggleProduct = (prodId) => {
        setExpandedProducts(prev => ({ ...prev, [prodId]: !prev[prodId] }))
    }

    return (
        <Card>
            <CardHeader>
                <CardTitle>Preview - Configuração Final</CardTitle>
            </CardHeader>
            <CardBody>
                <div className="mb-4">
                    <h5>Resumo</h5>
                    <div className="d-flex gap-2 mb-3">
                        <Badge color="dark" isLight>{data.categories?.length || 0} Categorias</Badge>
                        <Badge color="dark" isLight>{data.items?.length || 0} Produtos</Badge>
                        <Badge color="dark" isLight>{data.modifier_groups?.length || 0} Grupos de Complementos</Badge>
                    </div>
                </div>

                {/* Hierarquia: Categorias > Produtos > Complementos */}
                <div className="mb-4">
                    {data.categories?.map(category => {
                        const categoryProducts = data.items?.filter(item => 
                            category.app_item_ids?.includes(item.app_item_id)
                        ) || []
                        const isExpanded = expandedCategories[category.app_category_id]

                        return (
                            <Card key={category.app_category_id} className="mb-3 border-dark">
                                <CardBody>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div>
                                            <strong className="text-dark">{category.category_name}</strong>
                                            <Badge color="dark" isLight className="ms-2">
                                                {categoryProducts.length} produtos
                                            </Badge>
                                        </div>
                                        <Button
                                            color="link"
                                            size="sm"
                                            className="p-1 text-dark"
                                            onClick={() => toggleCategory(category.app_category_id)}
                                        >
                                            {isExpanded ? '▲' : '▼'}
                                        </Button>
                                    </div>

                                    {isExpanded && categoryProducts.length > 0 && (
                                        <div className="mt-3 ps-4 border-start border-3 border-dark">
                                            {categoryProducts.map(product => {
                                                const productData = allProducts?.find(p => p.id === product.app_item_id)
                                                const productModifiers = data.modifier_groups?.filter(mg => {
                                                    return productData?.complements?.includes(mg.app_modifier_group_id)
                                                }) || []
                                                const isProductExpanded = expandedProducts[product.app_item_id]

                                                return (
                                                    <Card key={product.app_item_id} className="mb-2 bg-light border-secondary">
                                                        <CardBody className="p-3">
                                                            <div className="d-flex align-items-center justify-content-between">
                                                                <div>
                                                                    <strong>{product.item_name}</strong>
                                                                    <div className="text-muted small">
                                                                        {Money.centsToMaskMoney(product.price || 0)}
                                                                    </div>
                                                                    {productModifiers.length > 0 && (
                                                                        <Badge color="dark" isLight className="mt-1">
                                                                            {productModifiers.length} grupos de complementos
                                                                        </Badge>
                                                                    )}
                                                                </div>
                                                                {productModifiers.length > 0 && (
                                                                    <Button
                                                                        color="link"
                                                                        size="sm"
                                                                        className="p-1 text-muted"
                                                                        onClick={() => toggleProduct(product.app_item_id)}
                                                                    >
                                                                        {isProductExpanded ? '▲' : '▼'}
                                                                    </Button>
                                                                )}
                                                            </div>

                                                            {isProductExpanded && productModifiers.length > 0 && (
                                                                <div className="mt-3 ps-3 border-start border-2 border-secondary">
                                                                    {productModifiers.map(modifier => (
                                                                        <div key={modifier.app_modifier_group_id} className="mb-3">
                                                                            <div className="fw-bold text-dark">
                                                                                {modifier.modifier_group_name}
                                                                            </div>
                                                                            <div className="small text-muted">
                                                                                Min: {modifier.quantity_min_permitted} | Max: {modifier.quantity_max_permitted}
                                                                            </div>
                                                                            <div className="ps-3 mt-2">
                                                                                {modifier.app_mg_items?.map(item => {
                                                                                    const complement = allComplements?.find(c => c.id === item.app_item_id)
                                                                                    if (!complement) return null
                                                                                    return (
                                                                                        <div key={item.app_item_id} className="d-flex justify-content-between py-1 small">
                                                                                            <span>• {complement.name}</span>
                                                                                            <span className="text-muted">
                                                                                                {Money.centsToMaskMoney(complement.price || 0)}
                                                                                            </span>
                                                                                        </div>
                                                                                    )
                                                                                })}
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            )}
                                                        </CardBody>
                                                    </Card>
                                                )
                                            })}
                                        </div>
                                    )}
                                </CardBody>
                            </Card>
                        )
                    })}
                </div>
            </CardBody>
        </Card>
    );
}

export default memo(PreviewStep);